import luckyDrawItem from '@/api/lucky-draw/lucky-draw-item'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
	...baseState
}

export const getters = {}

export const mutations = {
	...baseMutations
}

export const actions = {
	fetch(context, attrubutes = {}) {
		let params = Object.assign(
			{
				page: context.state.pagination.page,
				perPage: context.state.pagination.perPage,
				filter: {
					search: context.state.search
				}
			},
			attrubutes
		)
		return luckyDrawItem.get({ params }).then(response => {
			context.commit('RECEIVE_RESOURCES', response)
			return Promise.resolve(response)
		})
	},
	store(context, data) {
		return luckyDrawItem.store(data)
	},
	update(context, { id, data }) {
		return luckyDrawItem.update(id, data)
	},
	async find(context, id) {
		if (_.isEmpty(context.state.edit_data)) {
			let response = await luckyDrawItem.find(id)
			context.commit('SET_EDIT_DATA', response.data)
		}
	},
	upload(context, data) {
		return luckyDrawItem.upload(data)
	},
	destroy(context, id) {
		return luckyDrawItem.destroy(id)
	},
	changeIsEnable(context, { id, data }) {
		return luckyDrawItem.changeIsEnable(id, data)
	},
}
